export default "/_next/static/images/ctf-branch-a9c8d757b4c93ed7e57d9ecc2bf27913.svg";